import React from "react";
import Select from "react-select";
import { isMobile } from "react-device-detect";

const RenoSelect = (props) => {
  const { customClasses = {}, customStyles = {} } = props;
  const menuPortalTarget = props.menuPortalTarget ?? document.body;
  const minHeight = isMobile ? 45 : 40;

  const defaultStyles = {
    control: (base, { isDisabled }) => ({
      ...base,
      minHeight,
      height: 32,
      padding: 0,
      margin: 0,
      fontSize: 14,
      borderRadius: 12,
      backgroundColor: isDisabled ? "#fafafa" : base.backgroundColor,
      border: isDisabled
        ? "1px solid rgba(18, 18, 21, 0.1)"
        : "1px solid rgb(209, 213, 219)",
      boxShadow: "none",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "100%",
      margin: "0 auto",
      padding: "0 16px",
      fontSize: 14,
      borderRadius: 12,
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: 14,
      color: "#374151",
    }),
    input: (base) => ({
      ...base,
      fontSize: 14,
      margin: 0,
      padding: 0,
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: 14,
      color: "#949DAA",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 999999,
      fontSize: 14,
      backgroundColor: "#fff",
      border: "1px solid #e5e7eb",
      borderRadius: 12,
      overflow: "hidden",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
    }),
    option: (base, state) => ({
      ...base,
      fontSize: 14,
      padding: "8px 16px",
      cursor: "pointer",
      backgroundColor: state.isFocused ? "#f3f4f6" : "#fff",
      color: state.isFocused ? "#000" : "#374151",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      borderRadius: 12,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    multiValue: (base) => ({
      ...base,
      borderRadius: 6,
    }),
    multiValueLabel: (base) => ({
      ...base,
      fontSize: 14,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 999999,
    }),
  };

  const mergedStyles = {};
  const allKeys = new Set([...Object.keys(defaultStyles), ...Object.keys(customStyles)]);
  allKeys.forEach((key) => {
    const defaultFn = defaultStyles[key];
    const customFn = customStyles[key];
    if (customFn && typeof customFn === "function") {
      mergedStyles[key] = (base, state) => ({
        ...(typeof defaultFn === "function" ? defaultFn(base, state) : defaultFn || {}),
        ...customFn(base, state),
      });
    } else if (customFn && typeof customFn === "object") {
      mergedStyles[key] = customFn;
    } else {
      mergedStyles[key] = defaultFn;
    }
  });

  return (
    <Select
      {...props}
      classNames={customClasses}
      styles={mergedStyles}
      menuPortalTarget={menuPortalTarget}
      menuPosition="fixed"
    />
  );
};

export default RenoSelect;
